import { FormlyFieldConfig } from '@ngx-formly/core'

// CA-specific field definitions for the Canadian passport form (PPTC 054 / PPTC 203).
// Resolved by fields.service.ts buildField() via _.get(fields, key). Spread into the
// application registry (CA_APPLICATION_FIELDS) and the root registry (CA_FIELDS).

// US/CA country toggle — the "which country" selector used by CA passport address
// fields (e.g. "What country do you currently live in?"). This US/CA-only buttons
// format is specific to the CA application; the generic address country is a select.
export const CA_COUNTRY_FIELD: any = {
	type: 'buttons',
	props: {
		options: [
			{ label: 'United States', value: 'US' },
			{ label: 'Canada', value: 'CA' }
		],
		required: true
	}
}

// Special Areas (historical / sub-national place-of-birth names) keyed by country code.
// Used by the birth_country_detail mapped-select on the CA passport forms.
export const BIRTH_COUNTRY_DETAIL_MAP: { [key: string]: { label: string; value: string }[] } = {
  "AE": [
    {
      "label": "Abu Dhabi",
      "value": "172"
    },
    {
      "label": "Ajman",
      "value": "173"
    },
    {
      "label": "Dubai",
      "value": "193"
    },
    {
      "label": "Fugairah",
      "value": "198"
    },
    {
      "label": "Ras al Khaimah",
      "value": "232"
    },
    {
      "label": "Sharjah",
      "value": "245"
    },
    {
      "label": "Trucial States",
      "value": "004"
    },
    {
      "label": "Umm al Qaiwain",
      "value": "262"
    },
    {
      "label": "Union of Arab Emirates",
      "value": "005"
    }
  ],
  "AG": [
    {
      "label": "Barbuda",
      "value": "006"
    },
    {
      "label": "Redonda",
      "value": "233"
    }
  ],
  "AO": [
    {
      "label": "Cabinda",
      "value": "000"
    }
  ],
  "AS": [
    {
      "label": "Manua",
      "value": "217"
    },
    {
      "label": "Swains Islands",
      "value": "255"
    },
    {
      "label": "Tutuila",
      "value": "261"
    }
  ],
  "AU": [
    {
      "label": "New South Wales",
      "value": "220"
    },
    {
      "label": "Tasmania",
      "value": "008"
    }
  ],
  "BD": [
    {
      "label": "East Bengal",
      "value": "013"
    },
    {
      "label": "East Pakistan",
      "value": "014"
    }
  ],
  "BF": [
    {
      "label": "Upper Volta",
      "value": "011"
    },
    {
      "label": "Volta",
      "value": "012"
    }
  ],
  "BJ": [
    {
      "label": "Dahomey",
      "value": "010"
    },
    {
      "label": "People's Republic of Benin",
      "value": "226"
    }
  ],
  "BW": [
    {
      "label": "Bechuanaland",
      "value": "009"
    }
  ],
  "BY": [
    {
      "label": "Byelorussia",
      "value": "179"
    }
  ],
  "BZ": [
    {
      "label": "British Honduras",
      "value": "015"
    }
  ],
  "CD": [
    {
      "label": "Belgian Congo",
      "value": "COD"
    },
    {
      "label": "Congo Free State",
      "value": "183"
    },
    {
      "label": "Congo, Democratic Republic of the Congo",
      "value": "212"
    },
    {
      "label": "Congo/Kinshasa",
      "value": "185"
    },
    {
      "label": "Congo/Leopoldville",
      "value": "186"
    },
    {
      "label": "Zaire",
      "value": "161"
    }
  ],
  "CF": [
    {
      "label": "Ubangi-Shari",
      "value": "016"
    }
  ],
  "CG": [
    {
      "label": "Congo, People's Republic of the",
      "value": "182"
    },
    {
      "label": "Congo/Brazzaville",
      "value": "184"
    },
    {
      "label": "French Congo",
      "value": "196"
    },
    {
      "label": "Middle Congo",
      "value": "024"
    }
  ],
  "CL": [
    {
      "label": "Easter Island",
      "value": "017"
    }
  ],
  "CM": [
    {
      "label": "French Cameroon",
      "value": "021"
    }
  ],
  "CN": [
    {
      "label": "Hainan Island",
      "value": "202"
    },
    {
      "label": "Inner Mongolia",
      "value": "018"
    },
    {
      "label": "Manchuria",
      "value": "019"
    },
    {
      "label": "People's Republic of China",
      "value": "227"
    },
    {
      "label": "Sinkiang",
      "value": "246"
    },
    {
      "label": "Tibet",
      "value": "020"
    }
  ],
  "EC": [
    {
      "label": "Galapagos Islands",
      "value": "199"
    }
  ],
  "EG": [
    {
      "label": "Sinai Peninsula",
      "value": "027"
    }
  ],
  "EH": [
    {
      "label": "Spanish Sahara",
      "value": "250"
    }
  ],
  "ES": [
    {
      "label": "Balearic Islands",
      "value": "028"
    },
    {
      "label": "Canary Islands",
      "value": "030"
    },
    {
      "label": "Ceuta",
      "value": "029"
    },
    {
      "label": "Melilla",
      "value": "031"
    }
  ],
  "ET": [
    {
      "label": "Abyssinia",
      "value": "032"
    }
  ],
  "FI": [
    {
      "label": "ALAND ISLANDS",
      "value": "ALA"
    }
  ],
  "FJ": [
    {
      "label": "Fiji Islands",
      "value": "195"
    }
  ],
  "FK": [
    {
      "label": "Malvinas,  Islas",
      "value": "216"
    }
  ],
  "FM": [
    {
      "label": "Caroline Islands",
      "value": "035"
    },
    {
      "label": "Truk Islands",
      "value": "260"
    }
  ],
  "FR": [
    {
      "label": "Alsace-Lorraine",
      "value": "033"
    },
    {
      "label": "Corsica",
      "value": "034"
    },
    {
      "label": "FRENCH SOUTHERN TERRITORIES",
      "value": "ATF"
    }
  ],
  "GB": [
    {
      "label": "Belfast",
      "value": "176"
    },
    {
      "label": "Britain",
      "value": "163"
    },
    {
      "label": "BRITISH INDIAN OCEAN TERRITORY",
      "value": "IOT"
    },
    {
      "label": "Channel Islands",
      "value": "037"
    },
    {
      "label": "England",
      "value": "038"
    },
    {
      "label": "Great Britain",
      "value": "039"
    },
    {
      "label": "Northern Ireland",
      "value": "043"
    },
    {
      "label": "Orkney Islands",
      "value": "044"
    },
    {
      "label": "Scotland",
      "value": "045"
    },
    {
      "label": "Shetland Islands",
      "value": "046"
    },
    {
      "label": "Wales",
      "value": "047"
    }
  ],
  "GH": [
    {
      "label": "British Togoland",
      "value": "048"
    },
    {
      "label": "Gold Coast",
      "value": "049"
    }
  ],
  "GM": [
    {
      "label": "The Gambia",
      "value": "056"
    }
  ],
  "GN": [
    {
      "label": "French Guinea",
      "value": "050"
    }
  ],
  "GP": [
    {
      "label": "Desirade",
      "value": "051"
    },
    {
      "label": "Les Saintes",
      "value": "053"
    },
    {
      "label": "Marie-Galante",
      "value": "052"
    }
  ],
  "GQ": [
    {
      "label": "Annobon",
      "value": "175"
    },
    {
      "label": "Corisco",
      "value": "058"
    },
    {
      "label": "Elobey",
      "value": "265"
    },
    {
      "label": "Fernando Poo",
      "value": "194"
    },
    {
      "label": "Rio Muni",
      "value": "237"
    },
    {
      "label": "Spanish Guinea",
      "value": "249"
    }
  ],
  "GR": [
    {
      "label": "Crete",
      "value": "187"
    },
    {
      "label": "Dodecanese Islands",
      "value": "192"
    },
    {
      "label": "Rhodes",
      "value": "236"
    }
  ],
  "GW": [
    {
      "label": "Portuguese Guinea",
      "value": "057"
    }
  ],
  "GY": [
    {
      "label": "British Guiana",
      "value": "059"
    }
  ],
  "ID": [
    {
      "label": "Bali",
      "value": "061"
    },
    {
      "label": "Celebes",
      "value": "062"
    },
    {
      "label": "Java",
      "value": "064"
    },
    {
      "label": "Lombok",
      "value": "213"
    },
    {
      "label": "Madura",
      "value": "214"
    },
    {
      "label": "Moluccan Islands",
      "value": "218"
    },
    {
      "label": "Netherlands East Indies",
      "value": "065"
    },
    {
      "label": "Netherlands New Guinea",
      "value": "066"
    },
    {
      "label": "Sumatra",
      "value": "067"
    },
    {
      "label": "Timor",
      "value": "171"
    }
  ],
  "IE": [
    {
      "label": "Eire",
      "value": "071"
    },
    {
      "label": "Irish Free State",
      "value": "072"
    }
  ],
  "IN": [
    {
      "label": "Damao",
      "value": "188"
    },
    {
      "label": "Diu",
      "value": "191"
    },
    {
      "label": "Goa",
      "value": "200"
    },
    {
      "label": "Portuguese India",
      "value": "069"
    },
    {
      "label": "Punjab (East)",
      "value": "230"
    },
    {
      "label": "Sikkim",
      "value": "070"
    }
  ],
  "IQ": [
    {
      "label": "Mesopotamia",
      "value": "074"
    }
  ],
  "IR": [
    {
      "label": "Persia",
      "value": "073"
    }
  ],
  "IT": [
    {
      "label": "Elba",
      "value": "075"
    },
    {
      "label": "Sardinia",
      "value": "076"
    },
    {
      "label": "Sicily",
      "value": "077"
    }
  ],
  "JO": [
    {
      "label": "Transjordan",
      "value": "079"
    }
  ],
  "JP": [
    {
      "label": "Okinawa",
      "value": "081"
    }
  ],
  "KH": [
    {
      "label": "Kampuchea",
      "value": "189"
    },
    {
      "label": "Khmer Republic",
      "value": "210"
    }
  ],
  "KI": [
    {
      "label": "Gilbert Islands",
      "value": "082"
    }
  ],
  "KN": [
    {
      "label": "Nevis",
      "value": "085"
    },
    {
      "label": "St. Christopher",
      "value": "083"
    },
    {
      "label": "ST. KITTS",
      "value": "084"
    }
  ],
  "KP": [
    {
      "label": "Democratic People's Republic of Korea",
      "value": "190"
    }
  ],
  "LK": [
    {
      "label": "Ceylon",
      "value": "087"
    }
  ],
  "LS": [
    {
      "label": "Basutoland",
      "value": "088"
    }
  ],
  "LY": [
    {
      "label": "Tripolitania",
      "value": "086"
    }
  ],
  "MA": [
    {
      "label": "French Morocco",
      "value": "089"
    },
    {
      "label": "Ifni",
      "value": "203"
    },
    {
      "label": "International Zone of Tangier",
      "value": "204"
    },
    {
      "label": "Spanish Morocco",
      "value": "090"
    },
    {
      "label": "Tangier",
      "value": "091"
    }
  ],
  "MD": [
    {
      "label": "Republic of Moldavia",
      "value": "092"
    }
  ],
  "MG": [
    {
      "label": "Malagasy Republic",
      "value": "093"
    }
  ],
  "MK": [
    {
      "label": "Macedonia",
      "value": "268"
    }
  ],
  "MM": [
    {
      "label": "Burma",
      "value": "098"
    }
  ],
  "MN": [
    {
      "label": "Outer Mongolia",
      "value": "099"
    }
  ],
  "MW": [
    {
      "label": "Nyasaland",
      "value": "100"
    }
  ],
  "MY": [
    {
      "label": "British North Borneo",
      "value": "101"
    },
    {
      "label": "FEDERATION OF MALAYA",
      "value": "102"
    },
    {
      "label": "Johore",
      "value": "205"
    },
    {
      "label": "Kedah",
      "value": "208"
    },
    {
      "label": "Kelantan",
      "value": "209"
    },
    {
      "label": "Labuan",
      "value": "211"
    },
    {
      "label": "Malacca",
      "value": "215"
    },
    {
      "label": "Negri Sambilan",
      "value": "219"
    },
    {
      "label": "Pahang",
      "value": "223"
    },
    {
      "label": "Penang",
      "value": "103"
    },
    {
      "label": "Perak",
      "value": "228"
    },
    {
      "label": "Perlis",
      "value": "229"
    },
    {
      "label": "Sabah",
      "value": "241"
    },
    {
      "label": "Sarawak",
      "value": "104"
    },
    {
      "label": "Selanger",
      "value": "244"
    },
    {
      "label": "Straits Settlements",
      "value": "105"
    },
    {
      "label": "Trengganu",
      "value": "259"
    }
  ],
  "NA": [
    {
      "label": "South West Africa",
      "value": "106"
    }
  ],
  "NG": [
    {
      "label": "British Cameroon",
      "value": "107"
    }
  ],
  "NL": [
    {
      "label": "Holland",
      "value": "108"
    }
  ],
  "NO": [
    {
      "label": "BOUVET ISLAND",
      "value": "BVT"
    }
  ],
  "NU": [
    {
      "label": "Savage Island",
      "value": "243"
    }
  ],
  "NZ": [
    {
      "label": "Chatham Island",
      "value": "180"
    },
    {
      "label": "North Island",
      "value": "221"
    },
    {
      "label": "South Island",
      "value": "248"
    },
    {
      "label": "Steward Island",
      "value": "254"
    }
  ],
  "OM": [
    {
      "label": "Muscat and Oman",
      "value": "109"
    }
  ],
  "PA": [
    {
      "label": "Colon",
      "value": "181"
    },
    {
      "label": "Panama City",
      "value": "224"
    }
  ],
  "PF": [
    {
      "label": "Tahiti",
      "value": "257"
    }
  ],
  "PH": [
    {
      "label": "Philippine Islands",
      "value": "PHL"
    }
  ],
  "PK": [
    {
      "label": "Baluchistan",
      "value": "110"
    },
    {
      "label": "North Western Frontier Province",
      "value": "222"
    },
    {
      "label": "Punjab (West)",
      "value": "231"
    },
    {
      "label": "Sind",
      "value": "111"
    }
  ],
  "PL": [
    {
      "label": "Danzig",
      "value": "112"
    },
    {
      "label": "Gdansk",
      "value": "113"
    }
  ],
  "PM": [
    {
      "label": "Miquelon",
      "value": "122"
    }
  ],
  "PT": [
    {
      "label": "Azores",
      "value": "114"
    },
    {
      "label": "Madeira Islands",
      "value": "115"
    }
  ],
  "RO": [
    {
      "label": "Roumania",
      "value": "238"
    },
    {
      "label": "Rumania",
      "value": "239"
    }
  ],
  "RU": [
    {
      "label": "Siberia",
      "value": "117"
    }
  ],
  "SB": [
    {
      "label": "British Solomon Islands",
      "value": "119"
    }
  ],
  "SD": [
    {
      "label": "Anglo-Egyptian Sudan",
      "value": "118"
    }
  ],
  "SK": [
    {
      "label": "Slovakia",
      "value": "247"
    }
  ],
  "SO": [
    {
      "label": "British Somaliland",
      "value": "120"
    },
    {
      "label": "Italian Somaliland",
      "value": "157"
    },
    {
      "label": "Somali Democratic Republic",
      "value": "121"
    }
  ],
  "SR": [
    {
      "label": "Dutch Guiana",
      "value": "123"
    },
    {
      "label": "Republic of Surinam",
      "value": "234"
    }
  ],
  "ST": [
    {
      "label": "Principe",
      "value": "170"
    }
  ],
  "SY": [
    {
      "label": "Golan Heights",
      "value": "124"
    },
    {
      "label": "Syria",
      "value": "256"
    }
  ],
  "TC": [
    {
      "label": "Caicos Islands",
      "value": "125"
    }
  ],
  "TG": [
    {
      "label": "French Togoland",
      "value": "126"
    }
  ],
  "TH": [
    {
      "label": "Siam",
      "value": "127"
    }
  ],
  "TL": [
    {
      "label": "East Timor",
      "value": "TLS"
    }
  ],
  "TO": [
    {
      "label": "Friendly Islands",
      "value": "197"
    },
    {
      "label": "Tonga Islands",
      "value": "128"
    }
  ],
  "TT": [
    {
      "label": "Tobago",
      "value": "129"
    }
  ],
  "TV": [
    {
      "label": "Ellice Islands",
      "value": "131"
    }
  ],
  "TZ": [
    {
      "label": "Pemba Island",
      "value": "225"
    },
    {
      "label": "Tanganyika and Zanzibar",
      "value": "258"
    },
    {
      "label": "United Republic of Tanzania",
      "value": "263"
    },
    {
      "label": "Zanzibar",
      "value": "055"
    }
  ],
  "US": [
    {
      "label": "Aleutian Islands",
      "value": "136"
    }
  ],
  "VC": [
    {
      "label": "Grenadines,   The",
      "value": "201"
    }
  ],
  "VE": [
    {
      "label": "Margarita Island",
      "value": "137"
    }
  ],
  "VG": [
    {
      "label": "Anegada",
      "value": "174"
    },
    {
      "label": "Jost Van Dykes",
      "value": "206"
    },
    {
      "label": "Tortola",
      "value": "138"
    },
    {
      "label": "Virgin Gorda",
      "value": "264"
    }
  ],
  "VI": [
    {
      "label": "St. Croix",
      "value": "251"
    },
    {
      "label": "St. John",
      "value": "252"
    },
    {
      "label": "St. Thomas",
      "value": "253"
    }
  ],
  "VN": [
    {
      "label": "North VietNam",
      "value": "139"
    },
    {
      "label": "South VietNam",
      "value": "140"
    }
  ],
  "VU": [
    {
      "label": "New Hebrides",
      "value": "141"
    }
  ],
  "WS": [
    {
      "label": "British Samoa",
      "value": "178"
    },
    {
      "label": "Samoa",
      "value": "242"
    }
  ],
  "YE": [
    {
      "label": "Aden",
      "value": "144"
    },
    {
      "label": "Republic of Yemen",
      "value": "235"
    }
  ],
  "ZA": [
    {
      "label": "Republic of South Africa",
      "value": "148"
    },
    {
      "label": "Union of South Africa",
      "value": "147"
    }
  ],
  "ZM": [
    {
      "label": "Northern Rhodesia",
      "value": "154"
    }
  ],
  "ZW": [
    {
      "label": "Southern Rhodesia",
      "value": "155"
    }
  ]
}

export const CA_APPLICATION_FIELDS: { [key: string]: any } = {
	"parents": {
		"applicant_relationship": {
			"type": "buttons",
			"props": {
				"options": [
					{
						"label": "Mother",
						"value": "mother"
					},
					{
						"label": "Father",
						"value": "father"
					},
					{
						"label": "Legal Guardian",
						"value": "legal_guardian"
					}
				],
				"required": true
			}
		},
		"other_relationship": {
			"type": "buttons",
			"props": {
				"options": [
					{
						"label": "Mother",
						"value": "mother"
					},
					{
						"label": "Father",
						"value": "father"
					},
					{
						"label": "Legal Guardian",
						"value": "legal_guardian"
					}
				],
				"required": false
			},
			"expressions": {
				// a parent can only appear once; two legal guardians are fine
				"props.options": (field: FormlyFieldConfig) => {
					const taken = field.model?.application?.ca?.parents?.applicant_relationship
					const all = [
						{ label: "Mother", value: "mother" },
						{ label: "Father", value: "father" },
						{ label: "Legal Guardian", value: "legal_guardian" }
					]

					return taken === "mother" || taken === "father" ? all.filter(option => option.value !== taken) : all
				}
			}
		},
		"relationship": {
			"type": "input",
			"props": {
				"label": "Relationship",
				"maxLength": 50,
				"required": true
			}
		},
		"wedding_date": {
			"type": "datepicker",
			"props": {
				"view": "multi-year",
				"label": "Date of Marriage",
				"required": false
			}
		},
		"adoption": {
			"type": "buttons",
			"props": {
				"options": [
					{
						"label": "Yes",
						"value": "yes"
					},
					{
						"label": "No",
						"value": "no"
					}
				],
				"required": true
			}
		},
		"custody": {
			"type": "buttons",
			"props": {
				"options": [
					{
						"label": "Yes",
						"value": "yes"
					},
					{
						"label": "No",
						"value": "no"
					}
				],
				"required": true
			}
		}
	},
	"guarantor": {
		"years": {
			"type": "input",
			"props": {
				"max": 100,
				"min": 2,
				"step": 1,
				"type": "number",
				"label": "Number of years",
				"required": true
			},
			"className": "gwc-form__field gwc-form__field--grow"
		},
		"first_name": {
			"type": "name-field",
			"props": {
				"label": "First Name",
				"required": true,
				"maxLength": 40
			},
			"className": "gwc-form__field gwc-form__field--grow"
		},
		"middle_name": {
			"type": "name-field",
			"props": {
				"label": "Middle Name",
				"required": false,
				"maxLength": 40
			},
			"className": "gwc-form__field gwc-form__field--grow"
		},
		"last_name": {
			"type": "name-field",
			"props": {
				"label": "Last Name",
				"required": true,
				"maxLength": 40
			},
			"className": "gwc-form__field gwc-form__field--grow"
		},
		"date_of_birth": {
			"type": "datepicker",
			"props": {
				"view": "multi-year",
				"after": [
					{
						"date": "01/01/1800",
						"message": "Date of Birth must be after 01/01/1800"
					}
				],
				"label": "Date of Birth",
				"before": [
					{
						"date": "now",
						"message": "Date can’t be in the future"
					}
				],
				"required": true
			},
			"className": "gwc-form__field gwc-form__field--grow"
		},
		"relationship": {
			"type": "input",
			"props": {
				"label": "Relationship",
				"required": true,
				"maxLength": 70
			},
			"className": "gwc-form__field gwc-form__field--grow"
		},
		"phone_number": {
			"type": "masked-input",
			"props": {
				"mask": "(000) 000-0000",
				"label": "Phone Number",
				"required": true
			},
			"className": "gwc-form__field gwc-form__field--grow"
		},
		"extra_number": {
			"type": "masked-input",
			"props": {
				"mask": "(000) 000-0000",
				"label": "Other Number",
				"required": false
			},
			"className": "gwc-form__field gwc-form__field--grow"
		},
		"passport": {
			"number": {
				"type": "input",
				"props": {
					"label": "Passport Number",
					"required": true
				},
				"className": "gwc-form__field gwc-form__field--grow"
			},
			"issue_date": {
				"type": "datepicker",
				"props": {
					"view": "multi-year",
					"after": [
						{
							"key": "date_of_birth",
							"parent": "global",
							"message": "Date can't be before Date of Birth"
						}
					],
					"label": "Issue Date",
					"before": [
						{
							"key": "expiration_date",
							"parent": "local",
							"message": "Date can’t be after the expiration date"
						},
						{
							"date": "now",
							"message": "Date can’t be in the future"
						}
					],
					"required": true
				},
				"className": "gwc-form__field gwc-form__field--grow"
			},
			"expiration_date": {
				"type": "datepicker",
				"props": {
					"view": "multi-year",
					"after": [
						{
							"key": "issue_date",
							"parent": "local",
							"message": "Date can’t be before the issue date"
						},
						{
							"key": "date_of_birth",
							"parent": "global",
							"message": "Date can't be before Date of Birth"
						}
					],
					"label": "Expiration Date",
					"required": true
				},
				"className": "gwc-form__field gwc-form__field--grow"
			}
		},
		"address": {
			"type": "ca-plain-address-country"
		}
	},
	"travel_document": {
			"is_damaged": {
				"type": "buttons",
				"props": {
					"options": [
						{ "label": "Yes", "value": "yes" },
						{ "label": "No", "value": "no" }
					],
					"required": true
				}
			},
		"type": {
			"type": "select",
			"props": {
				"label": "Last Travel Document Type",
				"options": [
					{
						"label": "Passport",
						"value": "passport"
					},
					{
						"label": "Certificate of Identity",
						"value": "certificate_of_identity"
					},
					{
						"label": "Refugee Travel Document",
						"value": "refugee_travel_doc"
					}
				],
				"required": true
			},
			"className": "gwc-form__field gwc-form__field--grow"
		}
	},
	"had_travel_document": {
		"type": "buttons",
		"props": {
			"options": [
				{
					"label": "Yes",
					"value": "yes"
				},
				{
					"label": "No",
					"value": "no"
				}
			],
			"required": true
		}
	},
	"passport": {
		"expired": {
			"type": "buttons",
			"props": {
				"options": [
					{
						"label": "Yes",
						"value": "yes"
					},
					{
						"label": "No",
						"value": "no"
					}
				],
				"required": true
			}
		},
		"in_possession": {
			"type": "buttons",
			"props": {
				"options": [
					{
						"label": "Yes",
						"value": "yes"
					},
					{
						"label": "No",
						"value": "lost"
					}
				],
				"required": true
			}
		},
		"is_damaged": {
			"type": "buttons",
			"props": {
				"options": [
					{
						"label": "Yes",
						"value": "yes"
					},
					{
						"label": "No",
						"value": "no"
					}
				],
				"required": true
			}
		},
		"can_provide_info": {
			"type": "buttons",
			"props": {
				"options": [
					{
						"label": "Yes",
						"value": "yes"
					},
					{
						"label": "No",
						"value": "no"
					}
				],
				"required": true
			}
		},
		"number": {
			"type": "input",
			"props": {
				"label": "Passport Number"
			},
			"className": "gwc-form__field gwc-form__field--grow"
		},
		"issue_date": {
			"type": "datepicker",
			"props": {
				"view": "multi-year",
				"after": [
					{
						"key": "date_of_birth",
						"parent": "global",
						"message": "Date can't be before Date of Birth"
					}
				],
				"label": "Issue Date",
				"before": [
					{
						"key": "expiration_date",
						"parent": "local",
						"message": "Date can’t be after the expiration date"
					},
					{
						"date": "now",
						"message": "Date can’t be in the future"
					}
				]
			},
			"className": "gwc-form__field gwc-form__field--grow"
		},
		"expiration_date": {
			"type": "datepicker",
			"props": {
				"view": "multi-year",
				"after": [
					{
						"key": "issue_date",
						"parent": "local",
						"message": "Date can’t be before the issue date"
					},
					{
						"key": "date_of_birth",
						"parent": "global",
						"message": "Date can't be before Date of Birth"
					}
				],
				"label": "Expiration Date"
			},
			"className": "gwc-form__field gwc-form__field--grow"
		},
		"info_match": {
			"type": "buttons",
			"props": {
				"options": [
					{
						"label": "Yes",
						"value": "yes"
					},
					{
						"label": "No",
						"value": "no"
					}
				],
				"required": true
			}
		},
		"gender_match": {
			"type": "buttons",
			"props": {
				"options": [
					{
						"label": "Yes",
						"value": "yes"
					},
					{
						"label": "No",
						"value": "no"
					}
				],
				"required": true
			}
		},
		"first_name": {
			"type": "name-field",
			"props": {
				"label": "First Name",
				"required": true
			},
			"className": "gwc-form__field gwc-form__field--grow"
		},
		"middle_name": {
			"type": "name-field",
			"props": {
				"label": "Middle Name",
				"required": false
			},
			"className": "gwc-form__field gwc-form__field--grow"
		},
		"last_name": {
			"type": "name-field",
			"props": {
				"label": "Last Name",
				"required": true
			},
			"className": "gwc-form__field gwc-form__field--grow"
		},
		"date_of_birth": {
			"type": "datepicker",
			"props": {
				"view": "multi-year",
				"after": [
					{
						"date": "01/01/1800",
						"message": "Date of Birth must be after 01/01/1800"
					}
				],
				"label": "Date of Birth",
				"before": [
					{
						"date": "now",
						"message": "Date can’t be in the future"
					}
				],
				"required": true
			},
			"className": "gwc-form__field gwc-form__field--grow"
		},
		"birth_country": {
			"type": "country-autocomplete",
			"className": "gwc-form__field gwc-form__field--grow"
		},
		"birth_city": {
			"type": "name-field",
			"props": {
				"label": "City",
				"required": true,
				"maxLength": 25
			},
			"className": "gwc-form__field gwc-form__field--grow"
		},
		"birth_state": {
			"type": "state-province-autocomplete",
			"props": {
				"required": true,
				"parentKey": "application.ca.passport.birth_country"
			},
			"className": "gwc-form__field gwc-form__field--grow"
		},
		"gender": {
			"type": "buttons",
			"props": {
				"label": "Gender",
				"options": [
					{
						"icon": "icon-male",
						"label": "Male",
						"value": "male"
					},
					{
						"icon": "icon-female",
						"label": "Female",
						"value": "female"
					},
					{
						"label": "Unspecified",
						"value": "unspecified"
					}
				],
				"required": true
			}
		},
		"issue_country": {
			"type": "country-autocomplete",
			"props": {
				"required": false
			},
			"className": "gwc-form__field gwc-form__field--grow"
		},
		"issue_city": {
			"type": "name-field",
			"props": {
				"label": "City",
				"required": false,
				"maxLength": 25
			},
			"className": "gwc-form__field gwc-form__field--grow"
		},
		"last_used_date": {
			"type": "datepicker",
			"props": {
				"view": "multi-year",
				"after": [
					{
						"key": "issue_date",
						"parent": "local",
						"message": "Date can’t be before the issue date"
					},
					{
						"key": "date_of_birth",
						"parent": "global",
						"message": "Date can't be before Date of Birth"
					}
				],
				"label": "Last Used On",
				"before": [
					{
						"date": "now",
						"message": "Date can’t be in the future"
					}
				]
			},
			"className": "gwc-form__field gwc-form__field--grow"
		},
		"last_used_country": {
			"type": "country-autocomplete",
			"props": {
				"required": false
			},
			"className": "gwc-form__field gwc-form__field--grow"
		},
		"last_used_city": {
			"type": "name-field",
			"props": {
				"label": "City",
				"required": false,
				"maxLength": 25
			},
			"className": "gwc-form__field gwc-form__field--grow"
		}
	},
	"pptc203": {
		"lost_date": {
			"type": "datepicker",
			"props": {
				"view": "multi-year",
				"after": [
					{
						"key": "issue_date",
						"parent": "local",
						"message": "Date can’t be before the issue date"
					},
					{
						"key": "date_of_birth",
						"parent": "global",
						"message": "Date can't be before Date of Birth"
					}
				],
				"label": "Date",
				"before": [
					{
						"date": "now",
						"message": "Date can’t be in the future"
					}
				],
				"required": true
			},
			"className": "gwc-form__field gwc-form__field--grow"
		},
		"lost_details": {
			"type": "textarea",
			"props": {
				"rows": 2,
				"required": true,
				"placeholder": "Please provide details"
			}
		},
		"lost_recover": {
			"type": "textarea",
			"props": {
				"rows": 2,
				"required": true,
				"placeholder": "Please provide details"
			}
		},
		"report": {
			"seized": {
				"type": "buttons",
				"props": {
					"options": [
						{
							"label": "Yes",
							"value": "yes"
						},
						{
							"label": "No",
							"value": "no"
						}
					],
					"required": true
				}
			},
			"police_report": {
				"type": "buttons",
				"props": {
					"options": [
						{
							"label": "Yes",
							"value": "yes"
						},
						{
							"label": "No",
							"value": "no"
						}
					],
					"required": true
				}
			},
			"date": {
				"type": "datepicker",
				"props": {
					"view": "multi-year",
					"after": [
						{
							"key": "issue_date",
							"parent": "local",
							"message": "Date can’t be before the issue date"
						},
						{
							"key": "date_of_birth",
							"parent": "global",
							"message": "Date can't be before Date of Birth"
						}
					],
					"before": [
						{
							"date": "now",
							"message": "Date can’t be in the future"
						}
					]
				},
				"className": "gwc-form__field gwc-form__field--grow"
			},
			"file_no": {
				"type": "input",
				"props": {
					"label": "File Number",
					"required": false,
					"maxLength": 43
				},
				"className": "gwc-form__field gwc-form__field--grow"
			},
			"law_enf_auth": {
				"type": "input",
				"props": {
					"label": "Law Enforcement Authority",
					"required": false,
					"maxLength": 43
				},
				"className": "gwc-form__field gwc-form__field--grow"
			},
			"details": {
				"type": "textarea",
				"props": {
					"rows": 2,
					"placeholder": "Please provide details"
				}
			},
			"other_lost": {
				"type": "buttons",
				"props": {
					"options": [
						{
							"label": "Yes",
							"value": "yes"
						},
						{
							"label": "No",
							"value": "no"
						}
					],
					"required": true
				}
			}
		},
		"damaged": {
			"how": {
				"type": "textarea",
				"props": {
					"rows": 2,
					"placeholder": "Describe What Happened"
				}
			},
			"app_reason": {
				"type": "textarea",
				"props": {
					"rows": 2,
					"placeholder": "Please describe the reason"
				}
			},
			"date": {
				"type": "datepicker",
				"props": {
					"view": "multi-year",
					"after": [
						{
							"key": "issue_date",
							"parent": "local",
							"message": "Date can’t be before the issue date"
						},
						{
							"key": "date_of_birth",
							"parent": "global",
							"message": "Date can't be before Date of Birth"
						}
					],
					"label": "Last Used On",
					"before": [
						{
							"date": "now",
							"message": "Date can’t be in the future"
						}
					]
				},
				"className": "gwc-form__field gwc-form__field--grow"
			},
			"country": {
				"type": "country-autocomplete",
				"props": {
					"required": false
				},
				"className": "gwc-form__field gwc-form__field--grow"
			},
			"city": {
				"type": "name-field",
				"props": {
					"label": "City",
					"required": false,
					"maxLength": 25
				},
				"className": "gwc-form__field gwc-form__field--grow"
			}
		},
		"found": {
			"how": {
				"type": "textarea",
				"props": {
					"rows": 2,
					"placeholder": "Describe What Happened"
				}
			},
			"details": {
				"type": "textarea",
				"props": {
					"rows": 2
				}
			},
			"date": {
				"type": "datepicker",
				"props": {
					"view": "multi-year",
					"after": [
						{
							"key": "issue_date",
							"parent": "local",
							"message": "Date can’t be before the issue date"
						},
						{
							"key": "date_of_birth",
							"parent": "global",
							"message": "Date can't be before Date of Birth"
						}
					],
					"label": "Last Used On",
					"before": [
						{
							"date": "now",
							"message": "Date can’t be in the future"
						}
					]
				},
				"className": "gwc-form__field gwc-form__field--grow"
			},
			"country": {
				"type": "country-autocomplete",
				"props": {
					"required": false
				},
				"className": "gwc-form__field gwc-form__field--grow"
			},
			"city": {
				"type": "name-field",
				"props": {
					"label": "City",
					"required": false,
					"maxLength": 25
				},
				"className": "gwc-form__field gwc-form__field--grow"
			}
		}
	},
	"passport_validity": {
		"type": "buttons",
		"props": {
			"options": [
				{
					"label": "5 Years",
					"value": "5"
				},
				{
					"label": "10 Years",
					"value": "10"
				}
			],
			"required": true
		}
	},
	"passport_return": {
		"type": "buttons",
		"props": {
			"options": [
				{
					"label": "Yes",
					"value": "yes"
				},
				{
					"label": "No",
					"value": "no"
				}
			],
			"required": true
		}
	},
	"hide_place_of_birth": {
		"type": "gwa-checkbox",
		"props": {
			"label": "Request passport without place of birth",
			"center": true,
			"required": false
		},
		"className": "gwc-form__field"
	},
	"reference_1": {
		"first_name": {
			"type": "name-field",
			"props": {
				"label": "First Name",
				"required": true,
				"maxLength": 40
			},
			"className": "gwc-form__field gwc-form__field--grow"
		},
		"middle_name": {
			"type": "name-field",
			"props": {
				"label": "Middle Name",
				"required": false,
				"maxLength": 40
			},
			"className": "gwc-form__field gwc-form__field--grow"
		},
		"last_name": {
			"type": "name-field",
			"props": {
				"label": "Last Name",
				"required": true,
				"maxLength": 40
			},
			"className": "gwc-form__field gwc-form__field--grow"
		},
		"relationship": {
			"type": "input",
			"props": {
				"label": "Relationship",
				"required": true,
				"maxLength": 70
			},
			"className": "gwc-form__field gwc-form__field--grow"
		},
		"years": {
			"type": "input",
			"props": {
				"max": 100,
				"min": 2,
				"step": 1,
				"type": "number",
				"label": "Years",
				"required": true
			},
			"className": "gwc-form__field gwc-form__field--grow",
			"validation": {
				"messages": {
					"min": "Your reference must know you for at least 2 years"
				}
			},
			"validators": {
				"validation": [
					"decimal"
				]
			}
		},
		"email": {
			"type": "input",
			"props": {
				"label": "Email",
				"pattern": "\\w+([\\-+._']\\w+)*@\\w+([\\-._]\\w+)*\\.\\w+([\\-.]\\w+)*",
				"required": true,
				"maxLength": 33
			},
			"className": "gwc-form__field gwc-form__field--grow",
			"validation": {
				"messages": {
					"maxLength": "Your email must be less than 34 characters."
				}
			}
		},
		"phone_number": {
			"type": "masked-input",
			"props": {
				"mask": "(000) 000-0000",
				"label": "Phone Number",
				"required": true
			},
			"className": "gwc-form__field gwc-form__field--grow"
		},
		"extra_number": {
			"type": "masked-input",
			"props": {
				"mask": "(000) 000-0000",
				"label": "Additional Number",
				"required": false
			},
			"className": "gwc-form__field gwc-form__field--grow"
		},
		"address": {
			"type": "ca-plain-address-country"
		}
	},
	"reference_2": {
		"first_name": {
			"type": "name-field",
			"props": {
				"label": "First Name",
				"required": true,
				"maxLength": 40
			},
			"className": "gwc-form__field gwc-form__field--grow"
		},
		"middle_name": {
			"type": "name-field",
			"props": {
				"label": "Middle Name",
				"required": false,
				"maxLength": 40
			},
			"className": "gwc-form__field gwc-form__field--grow"
		},
		"last_name": {
			"type": "name-field",
			"props": {
				"label": "Last Name",
				"required": true,
				"maxLength": 40
			},
			"className": "gwc-form__field gwc-form__field--grow"
		},
		"relationship": {
			"type": "input",
			"props": {
				"label": "Relationship",
				"required": true,
				"maxLength": 70
			},
			"className": "gwc-form__field gwc-form__field--grow"
		},
		"years": {
			"type": "input",
			"props": {
				"max": 100,
				"min": 2,
				"step": 1,
				"type": "number",
				"label": "Years",
				"required": true
			},
			"className": "gwc-form__field gwc-form__field--grow",
			"validation": {
				"messages": {
					"min": "Your reference must know you for at least 2 years"
				}
			},
			"validators": {
				"validation": [
					"decimal"
				]
			}
		},
		"email": {
			"type": "input",
			"props": {
				"label": "Email",
				"pattern": "\\w+([\\-+._']\\w+)*@\\w+([\\-._]\\w+)*\\.\\w+([\\-.]\\w+)*",
				"required": true,
				"maxLength": 33
			},
			"className": "gwc-form__field gwc-form__field--grow",
			"validation": {
				"messages": {
					"maxLength": "Your email must be less than 34 characters."
				}
			}
		},
		"phone_number": {
			"type": "masked-input",
			"props": {
				"mask": "(000) 000-0000",
				"label": "Phone Number",
				"required": true
			},
			"className": "gwc-form__field gwc-form__field--grow"
		},
		"extra_number": {
			"type": "masked-input",
			"props": {
				"mask": "(000) 000-0000",
				"label": "Additional Number",
				"required": false
			},
			"className": "gwc-form__field gwc-form__field--grow"
		},
		"address": {
			"type": "ca-plain-address-country"
		}
	}
}

export const CA_FIELDS: { [key: string]: any } = {
	"ca": {
		birth_country_detail: {
			type: 'mapped-select',
			props: {
				label: 'Special Areas',
				parentKey: 'birth_country',
				enableNone: true,
				mappedOptions: BIRTH_COUNTRY_DETAIL_MAP
			}
		},
		"citizenship": {
			"proof": {
				"type": {
					"type": "buttons",
					"props": {
						"options": [
							{
								"label": "Canadian Birth Certificate",
								"value": "birth_certificate"
							},
							{
								"label": "Certificate of Canadian Citizenship",
								"value": "citizenship_certificate"
							}
						],
						"required": true
					}
				},
				"number": {
					"type": "input",
					"props": {
						"label": "Certificate Number",
						"required": true,
						"maxLength": 20
					},
					"className": "gwc-form__field gwc-form__field--grow",
					"validation": {
						"messages": {
							"maxLength": "Certificate number must be less than 21 characters."
						}
					}
				},
				"issue_date": {
					"type": "datepicker",
					"props": {
						"view": "multi-year",
						"after": [
							{
								"key": "date_of_birth",
								"parent": "global",
								"message": "Date can't be before Date of Birth"
							}
						],
						"label": "Issue Date",
						"before": [
							{
								"date": "now",
								"message": "Date can’t be in the future"
							}
						],
						"required": true
					},
					"className": "gwc-form__field gwc-form__field--grow"
				}
			}
		}
	},
	"parents": {
		"parent_1": {
			"last_name": {
				"type": "name-field",
				"props": {
					"label": "Last Name",
					"required": true,
					"maxLength": 40
				},
				"className": "gwc-form__field gwc-form__field--grow"
			}
		}
	}
}
